import { render, staticRenderFns } from "./SubjectResultsSummaryComponent.vue?vue&type=template&id=8a559228&scoped=true&"
import script from "./SubjectResultsSummaryComponent.vue?vue&type=script&lang=js&"
export * from "./SubjectResultsSummaryComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubjectResultsSummaryComponent.vue?vue&type=style&index=0&id=8a559228&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a559228",
  null
  
)

export default component.exports